import React, { useState } from 'react';
import { Navigate, Link, useNavigate } from 'react-router-dom';
import { doSignInWithEmailAndPassword } from '../../../firebase/auth';
import { useAuth } from '../../../contexts/authContext';
import './login.css';


const Login = () => {
    const { userLoggedIn } = useAuth();
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isSigningIn, setIsSigningIn] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!isSigningIn) {
            setIsSigningIn(true);
            try {
                await doSignInWithEmailAndPassword(email, password);
                navigate('/bot');
            } catch (error) {
                setIsSigningIn(false);
                setErrorMessage(error.message);
            }
        }
    };

    return (
        <div className="login-page"> {/* Added wrapper div */}
            {userLoggedIn && <Navigate to={'/home'} replace={true} />}

            <main className="main-content">
                <div className="login-box">
                    <div className="text-center">
                        <div className="welcome-message">
                            <h3>Welcome Back</h3>
                        </div>
                    </div>
                    <form onSubmit={onSubmit} className="login-form">
                        <div className="form-group">
                            <label className="form-label">Email</label>
                            <input
                                type="email"
                                autoComplete="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="form-input"
                            />
                        </div>
                        <div className="form-group">
                            <div className="password-label-wrapper"> {/* Added wrapper for label and link */}
                                <label className="form-label">Password</label>
                                <Link to={'/reset'} className="forgot-password-link">
                                    Forgot Password?
                                </Link>
                            </div>
                            <input
                                type="password"
                                autoComplete="current-password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="form-input"
                            />
                        </div>
                        {errorMessage && <span className="error-message">{errorMessage}</span>}
                        <button type="submit" disabled={isSigningIn} className="submit-button">
                            {isSigningIn ? 'Signing In...' : 'Sign In'}
                        </button>
                    </form>
                    <p className="signup-link">
                        Don't have an account? <Link to={'/register'}>Sign up</Link>
                    </p>
                </div>
            </main>
        </div>
    );
};

export default Login;